<template>
	<v-dialog :value="true" persistent max-width="1000px">
		<v-card>
			<v-toolbar flat dense>
				<v-toolbar-title class="subheading">{{title}}</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon @click="onCancelClick">
					<v-icon>close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text class="pt-0">
				<loading-indicator v-if="isLoadingDiff" loading-text="Loading Changes..." />
				<code-diff v-else-if="isDiffLoaded" 
				:old-string="diff.previousContent" 
				:new-string="diff.currentContent" 
				output-format="side-by-side" 
				diffStyle="char" 
				language="html" />
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn flat @click="onCancelClick">Cancel</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import LoadingIndicator from '@/components/common/LoadingIndicator';

	export default {
		components: {
			LoadingIndicator
		},
		props: {
			hrDocumentId: {
				type: String,
				required: true
			},
			versionNo: {
				type: Number,
				required: true
			},
		},
		data() {
			return {
				isLoadingDiff: false,
				isDiffLoaded: false,
				diff: null
			};
		},
		created() {
			this.loadDiff();
		},
		computed: {
			title() {
				const previousVersionNo = this.versionNo - 1;
				return `Document updates from version ${previousVersionNo} to ${this.versionNo}`;
			}
		},
		methods: {
			async loadDiff() {
				this.isLoadingDiff = true;
				const result = await this.$store.dispatch('hrDocuments/getDiff', { id: this.hrDocumentId, versionNo: this.versionNo });
				if (result.isSuccess) {
					this.diff = result.data;
					this.isDiffLoaded = true;
				}
				this.isLoadingDiff = false;
			},
			onCancelClick() {
				this.$emit('onCancel');
			}
		}
	};
</script>